import { RefObject, createContext, useContext } from 'react';

interface GraphqlContext {
  refreshWsCable: () => void;
  setApiKey: (apiKey: string | undefined) => void;
  activeQueries: RefObject<number>;
}

export const GraphqlContext = createContext<GraphqlContext | null>(null);

export const useGraphqlContext = () => useContext(GraphqlContext)!;
